type InjectionTokensKeys =
  | 'I18n'
  | 'Logger'
  | 'FeatureFlagsProvider'
  | 'HttpClient'
  | 'CachedHttpClient'
  | 'GeocodeApi'
  | 'AccountWebClient'
  | 'JetStreamRasterClient'
  | 'DatasetCache'
  | 'DexieDB'
  | 'AmplitudeMetricsProvider'
  | 'KeyValuePersister'
  | 'Authenticator'
  | 'StatePersister'
  | 'StatePersisterStates'
  | 'MetricsService'
  | 'TrackingService'
  | 'MapLayerState'
  | 'UserChartUploadState'
  | 'UserGeometryUploadState'
  | 'UserGeometryLayerVisibilityState'
  | 'UserWaypointVisibilityState'
  | 'ProceduresState'
  | 'RouteState'
  | 'MapState'
  | 'SettingsState'
  | 'AuthState'
  | 'FlightState'
  | 'RouteNavigationState'
  | 'LocalTempDBState'
  | 'FeatureFlagsRepository'
  | 'AirspaceRepository'
  | 'MeteorologyRepository'
  | 'AeroInfoRepository'
  | 'UserRoutesRepository'
  | 'UserWaypointsRepository'
  | 'ProceduresRepository'
  | 'AircraftModelRepository'
  | 'UserAircraftsRepository'
  | 'DefaultWeightsRepository'
  | 'FuelRepository'
  | 'WBAirplaneFillRepository'
  | 'WBProfileAirplaneRepository'
  | 'WBProfileAirplaneTemplateRepository'
  | 'NotamRepository'
  | 'ObstacleRepository'
  | 'UserChartRepository'
  | 'UserGeometryRepository'
  | 'ChartConverterWebClient'
  | 'UserChartsWebClient'
  | 'UserChartSyncService'
  | 'UserChartTilesPrefetchService'
  | 'CheckUserChartNameExistsUseCase'
  | 'DeleteUserChartsLocalDataUseCase'
  | 'DeleteUserChartUseCase'
  | 'DownloadUserChartOriginalUseCase'
  | 'LoadUserChartsUseCase'
  | 'LoadUserChartUseCase'
  | 'PrepareUserChartUseCase'
  | 'RefreshUserChartsUseCase'
  | 'SaveUserChartUseCase'
  | 'UpdateUserChartUseCase'
  | 'UserGeometriesWebClient'
  | 'UserGeometrySyncService'
  | 'CheckUserGeometryFileExistsUseCase'
  | 'CheckUserGeometryNameExistsUseCase'
  | 'DeleteUserGeometriesLocalDataUseCase'
  | 'DeleteUserGeometryUseCase'
  | 'LoadUserGeometriesUseCase'
  | 'LoadUserGeometryUseCase'
  | 'PrepareUserGeometryUseCase'
  | 'SaveUserGeometryUseCase'
  | 'UpdateUserGeometryUseCase'
  | 'UpdateGeometriesLayersUseCase'
  | 'NavaidRepository'
  | 'UndoRouteUseCase'
  | 'RouteStateSideEffects'
  | 'CruiseAltitudeSuggester'

const InjectionTokens: Record<InjectionTokensKeys, symbol> = {
  I18n: Symbol.for('I18n'),
  Logger: Symbol.for('Logger'),
  FeatureFlagsProvider: Symbol.for('FeatureFlagsProvider'),

  // WebClients
  HttpClient: Symbol.for('HttpClient'),
  CachedHttpClient: Symbol.for('CachedHttpClient'),
  GeocodeApi: Symbol.for('GeocodeApi'),
  AccountWebClient: Symbol.for('AccountWebClient'),
  AmplitudeMetricsProvider: Symbol.for('AmplitudeMetricsProvider'),
  JetStreamRasterClient: Symbol.for('JetStreamRasterClient'),
  DatasetCache: Symbol.for('DatasetCache'),
  DexieDB: Symbol.for('DexieDB'),

  // Persistence
  KeyValuePersister: Symbol.for('KeyValuePersister'),

  // Services
  Authenticator: Symbol.for('Authenticator'),
  StatePersister: Symbol.for('StatePersister'),
  StatePersisterStates: Symbol.for('StatePersisterStates'),
  MetricsService: Symbol.for('MetricsService'),
  TrackingService: Symbol.for('TrackingService'),
  RouteStateSideEffects: Symbol.for('RouteStateSideEffects'),
  CruiseAltitudeSuggester: Symbol.for('CruiseAltitudeSuggester'),

  // Global States
  MapLayerState: Symbol.for('MapLayerState'),
  UserChartUploadState: Symbol.for('UserChartUploadState'),
  UserGeometryUploadState: Symbol.for('UserGeometryUploadState'),
  UserGeometryLayerVisibilityState: Symbol.for('UserGeometryLayerVisibilityState'),
  UserWaypointVisibilityState: Symbol.for('UserWaypointVisibilityState'),
  RouteState: Symbol.for('RouteState'),
  MapState: Symbol.for('MapState'),
  SettingsState: Symbol.for('SettingsState'),
  ProceduresState: Symbol.for('ProceduresState'),
  AuthState: Symbol.for('AuthState'),
  FlightState: Symbol.for('FlightState'),
  RouteNavigationState: Symbol.for('RouteNavigationState'),
  LocalTempDBState: Symbol.for('LocalTempDBState'),

  // Repositories
  FeatureFlagsRepository: Symbol.for('FeatureFlagsRepository'),
  AirspaceRepository: Symbol.for('AirspaceRepository'),
  MeteorologyRepository: Symbol.for('MeteorologyRepository'),
  AeroInfoRepository: Symbol.for('AeroInfoRepository'),
  UserRoutesRepository: Symbol.for('UserRoutesRepository'),
  UserWaypointsRepository: Symbol.for('UserWaypointsRepository'),
  ProceduresRepository: Symbol.for('ProceduresRepository'),
  AircraftModelRepository: Symbol.for('AircraftModelRepository'),
  UserAircraftsRepository: Symbol.for('UserAircraftsRepository'),
  DefaultWeightsRepository: Symbol.for('DefaultWeightsRepository'),
  FuelRepository: Symbol.for('FuelRepository'),
  WBAirplaneFillRepository: Symbol.for('WBAirplaneFillRepository'),
  WBProfileAirplaneRepository: Symbol.for('WBProfileAirplaneRepository'),
  WBProfileAirplaneTemplateRepository: Symbol.for('WBProfileAirplaneTemplateRepository'),
  NotamRepository: Symbol.for('NotamRepository'),
  ObstacleRepository: Symbol.for('ObstacleRepository'),
  UserChartRepository: Symbol.for('UserChartRepository'),
  UserGeometryRepository: Symbol.for('UserGeometryRepository'),

  // User Charts web clients
  ChartConverterWebClient: Symbol.for('ChartConverterWebClient'),
  UserChartsWebClient: Symbol.for('UserChartsWebClient'),

  // User Charts services
  UserChartSyncService: Symbol.for('UserChartSyncService'),
  UserChartTilesPrefetchService: Symbol.for('UserChartTilesPrefetchService'),

  // User Charts use cases
  CheckUserChartNameExistsUseCase: Symbol.for('CheckUserChartNameExistsUseCase'),
  DeleteUserChartsLocalDataUseCase: Symbol.for('DeleteUserChartsLocalDataUseCase'),
  DeleteUserChartUseCase: Symbol.for('DeleteUserChartUseCase'),
  DownloadUserChartOriginalUseCase: Symbol.for('DownloadUserChartOriginalUseCase'),
  LoadUserChartsUseCase: Symbol.for('LoadUserChartsUseCase'),
  LoadUserChartUseCase: Symbol.for('LoadUserChartUseCase'),
  PrepareUserChartUseCase: Symbol.for('PrepareUserChartUseCase'),
  RefreshUserChartsUseCase: Symbol.for('RefreshUserChartsUseCase'),
  SaveUserChartUseCase: Symbol.for('SaveUserChartUseCase'),
  UpdateUserChartUseCase: Symbol.for('UpdateUserChartUseCase'),

  // User Geometries web client
  UserGeometriesWebClient: Symbol.for('UserGeometriesWebClient'),

  // User Geometries services
  UserGeometrySyncService: Symbol.for('UserGeometrySyncService'),

  // User Geometries use cases
  CheckUserGeometryFileExistsUseCase: Symbol.for('CheckUserGeometryFileExistsUseCase'),
  CheckUserGeometryNameExistsUseCase: Symbol.for('CheckUserGeometryNameExistsUseCase'),
  DeleteUserGeometriesLocalDataUseCase: Symbol.for('DeleteUserGeometriesLocalDataUseCase'),
  DeleteUserGeometryUseCase: Symbol.for('DeleteUserGeometryUseCase'),
  LoadUserGeometriesUseCase: Symbol.for('LoadUserGeometriesUseCase'),
  LoadUserGeometryUseCase: Symbol.for('LoadUserGeometryUseCase'),
  PrepareUserGeometryUseCase: Symbol.for('PrepareUserGeometryUseCase'),
  SaveUserGeometryUseCase: Symbol.for('SaveUserGeometryUseCase'),
  UpdateUserGeometryUseCase: Symbol.for('UpdateUserGeometryUseCase'),
  UpdateGeometriesLayersUseCase: Symbol.for('UpdateGeometriesLayersUseCase'),
  NavaidRepository: Symbol.for('NavaidRepository'),

  // UseCases
  UndoRouteUseCase: Symbol.for('UndoRouteUseCase')
}

export { InjectionTokens }
